import PropTypes from "prop-types";

import { roundOff } from "utils";
import { RADIAN } from "utils/constants";
import { PieChart } from "components/Chart";
import { unixToDateTime } from "utils/date";

const TooltipContent = ({ active, payload }) => {
  if (active && payload && payload.length) {
    return (
      <div className="chart-tooltip">
        <span className="datetime">
          {unixToDateTime(payload[0].payload.name)}
        </span>
        {payload.map((p, i) => {
          return (
            <div key={i} className="label" style={{ color: p.color }}>
              <span>{p.name} </span>
              <span>{roundOff(p.value * 100)}%</span>
            </div>
          );
        })}
      </div>
    );
  }

  return null;
};

const LabelContent = ({
  cx,
  cy,
  midAngle,
  innerRadius,
  outerRadius,
  percent,
}) => {
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return percent > 5 ? (
    <text
      x={x}
      y={y}
      fill="white"
      textAnchor={x > cx ? "start" : "end"}
      dominantBaseline="central"
    >
      {`${roundOff(percent * 100, 0)}%`}
    </text>
  ) : null;
};

const LegendContent = ({ payload }) => {
  return (
    <ul>
      {payload.map((entry, index) => (
        <li key={`item-${index}`}>
          <span
            className="line"
            style={{ backgroundColor: entry.payload.color }}
          ></span>
          {entry.value}
        </li>
      ))}
    </ul>
  );
};

export const StrategyPieChart = ({
  data = [],
  showLegend = true,
  innerRadius = 50,
  ...props
}) => {
  return (
    <div style={{ width: "100%" }} className="pie-chart-wrapper">
      <PieChart
        data={data}
        showLegend={showLegend}
        innerRadius={innerRadius}
        labelContent={LabelContent}
        legendContent={LegendContent}
        tooltipContent={TooltipContent}
        {...props}
      />
    </div>
  );
};

StrategyPieChart.propTypes = {
  height: PropTypes.number,
  data: PropTypes.array,
  showLegend: PropTypes.bool,
  innerRadius: PropTypes.number,
};

TooltipContent.propTypes = {
  active: PropTypes.bool,
  payload: PropTypes.array,
};
TooltipContent.defaultProps = {
  active: false,
  payload: [],
};

LabelContent.propTypes = {
  cx: PropTypes.number,
  cy: PropTypes.number,
  midAngle: PropTypes.number,
  innerRadius: PropTypes.number,
  outerRadius: PropTypes.number,
  percent: PropTypes.number,
};

LegendContent.propTypes = {
  payload: PropTypes.array,
};
